import React, { useState, useEffect } from 'react';
import { authService } from '../services/api';

const InviteManager = () => {
  const [invites, setInvites] = useState([]);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [roleId, setRoleId] = useState(3); // Default to Staff role
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  useEffect(() => {
    loadInvites();
  }, []);
  
  const loadInvites = async () => {
    try {
      const response = await authService.getInvites();
      setInvites(response.data.invites || []);
    } catch (err) {
      console.error('Failed to load invites:', err);
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    
    try {
      // Prepare invite data according to CSV: first_name, last_name, email, role_id
      const inviteData = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        role_id: roleId
      };
      
      console.log('Sending invite with data:', inviteData);
      
      await authService.createInvite(inviteData);
      setSuccess(`Invitation sent to ${firstName} ${lastName} (${email})`);
      
      // Clear form
      setFirstName('');
      setLastName('');
      setEmail('');
      setRoleId(3); // Reset to Staff role
      
      loadInvites(); // Refresh the list
    } catch (err) {
      console.error('Failed to send invitation:', err);
      setError(err.response?.data?.message || 'Failed to send invitation');
    } finally {
      setLoading(false);
    }
  };
  
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };
  
  const getRoleName = (roleId) => {
    switch (roleId) {
      case 1: return 'Super Admin';
      case 2: return 'Admin';
      case 3: return 'Staff';
      default: return 'Unknown';
    }
  };
  
  return (
    <div className="invite-manager">
      <h2>Manage Invitations</h2>
      <div className="invite-form">
        <h3>Send New Invitation</h3>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
                     <div className="form-group">
             <label htmlFor="roleId">Role</label>
             <select
               id="roleId"
               value={roleId}
               onChange={(e) => setRoleId(parseInt(e.target.value))}
               required
             >
               <option value="3">Staff</option>
               <option value="2">Admin</option>
               <option value="1">Super Admin</option>
             </select>
           </div>
          
          <button 
            type="submit" 
            className="submit-btn" 
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Invitation'}
          </button>
        </form>
      </div>
      
      <div className="invites-list">
        <h3>Sent Invitations</h3>
        {invites.length === 0 ? (
          <p>No invitations have been sent yet.</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Expires</th>
                <th>Sent At</th>
              </tr>
            </thead>
            <tbody>
              {invites.map((invite) => (
                <tr key={invite.id}>
                                     <td>{invite.first_name}</td>
                   <td>{invite.last_name}</td>
                   <td>{invite.email}</td>
                   <td>{getRoleName(invite.role_id)}</td>
                  <td>{invite.is_accepted ? 'Accepted' : 'Pending'}</td>
                  <td>{formatDate(invite.expires_at)}</td>
                  <td>{formatDate(invite.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default InviteManager; 